"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useStack_exports = {};
__export(useStack_exports, {
  StackStateProvider: () => StackStateProvider,
  useStack: () => useStack
});
module.exports = __toCommonJS(useStack_exports);
var import_react = require("react");
var import_getPathFromState = require("../fork/getPathFromState");
var import_StackToolbar = require("../layouts/stack-utils/StackToolbar.shared");
var import_linkingConfig = require("../router/linkingConfig");
var StackContext = (0, import_react.createContext)(null);
function StackStateProvider(param) {
  var { state, descriptors, children } = param;
  var linking = (0, import_linkingConfig.getResolvedLinking)();
  var value = (0, import_react.useMemo)(function() {
    var screens = state.routes.map(function(route, index) {
      var _ref, _route_params;
      var descriptor = descriptors[route.key];
      var options = (0, import_StackToolbar.exposeStackToolbarConfig)(descriptor.options);
      var href = ((_ref = linking === null || linking === void 0 ? void 0 : linking.getPathFromState) !== null && _ref !== void 0 ? _ref : import_getPathFromState.getPathFromState)({
        ...state,
        index
      }, linking === null || linking === void 0 ? void 0 : linking.config);
      return {
        key: route.key,
        name: route.name,
        params: (_route_params = route.params) !== null && _route_params !== void 0 ? _route_params : {},
        href,
        isFocused: index === state.index,
        keepMounted: options.keepMounted === true,
        options,
        element: descriptor.render()
      };
    });
    return {
      screens,
      focused: screens[state.index]
    };
  }, [
    descriptors,
    linking,
    state
  ]);
  return (0, import_react.createElement)(StackContext.Provider, {
    value
  }, children);
}
function useStack() {
  var value = (0, import_react.useContext)(StackContext);
  if (!value) {
    throw new Error("useStack() must be called inside a <Stack>. it is web-only: on native the stack is rendered by react-navigation.");
  }
  return value;
}
//# sourceMappingURL=useStack.js.map
